var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextjs = function SvgNextjs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "nextjs_svg__mask0_408_134",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 180,
    height: 180
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nextjs_svg__mask0_408_134)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.508 157.52L69.142 54H54V125.97H66.1136V69.3836L139.999 164.845C143.333 162.614 146.509 160.165 149.508 157.52Z",
    fill: "url(#nextjs_svg__paint0_linear_408_134)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 54,
    width: 12,
    height: 72,
    fill: "url(#nextjs_svg__paint1_linear_408_134)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nextjs_svg__paint0_linear_408_134",
    x1: 109,
    y1: 116.5,
    x2: 144.5,
    y2: 160.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nextjs_svg__paint1_linear_408_134",
    x1: 121,
    y1: 54,
    x2: 120.799,
    y2: 106.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
export default SvgNextjs;